import React from 'react';
import styled from 'styled-components';
import {smallMediaQuery} from '../Grid';
import {
  getSidebarHeight,
  GridRoot,
  slideContentWidth,
  slideContentWidthSmall,
} from './SharedStyling';

const SlideContainer = styled(GridRoot)`
  width: ${slideContentWidth}px;

  @media ${smallMediaQuery} {
    width: ${slideContentWidthSmall}px;
  }
`;

interface Props {
  children: React.ReactChild | React.ReactChild[];
}

export default (props: Props) => {
  return (
    <SlideContainer
      style={{
        height: getSidebarHeight(),
      }}
    >
      {props.children}
    </SlideContainer>
  );
};
